'use client';

import { c as _c } from "react/compiler-runtime";
type Props = {
  setShowTrollAnimation: (show: boolean) => void;
};

// All four loops here are decorative and now live as CSS keyframes
// (tailwind.config.js). The old root `exit` never ran — PostItemBody renders
// this behind a plain `&&` with no AnimatePresence above it.
const AnimatedTroll = props => {
  const $ = _c(5);
  const {
    setShowTrollAnimation
  } = props;
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <h2 className="mb-2 animate-troll-title text-xl font-semibold text-primary">You've Been Trolled! 🤪</h2>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <p className="mb-3 animate-troll-pulse text-center text-textPrimary">This post was marked as trolling content.<br />Don't take it too seriously!</p>;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <div className="flex animate-troll-rock gap-2">{Array(3).fill(0).map(_temp)}</div>;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== setShowTrollAnimation) {
    t3 = <div className="anim-enter mb-4 rounded-xl bg-background-secondary/80 p-4 backdrop-blur-sm [--enter-duration:300ms] [--enter-ease:cubic-bezier(0,0,0.2,1)] [--enter-y:-50px]"><div className="flex flex-col items-center">{t0}{t1}{t2}<button className="mt-3 rounded-md bg-primary px-3 py-1 text-sm font-emphasis text-primary-foreground transition-transform duration-200 hover:scale-[1.05] active:scale-[0.95]" onClick={e => {
          e.stopPropagation();
          setShowTrollAnimation(false);
        }}>Got it!</button></div></div>;
    $[3] = setShowTrollAnimation;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  return t3;
};
export default AnimatedTroll;
function _temp(_, i) {
  return <span key={i} style={{
    animationDelay: `${i * 100}ms`
  }} className="animate-troll-bounce text-2xl">🦄</span>;
}